export function scrollToSection(id: string) {
  const anchorElement = document.getElementById(id);
  const offsetMargin = 92;
  const offset =
    anchorElement!.getBoundingClientRect().top + window.scrollY - offsetMargin;

  window.scrollTo({
    top: offset,
    behavior: "smooth",
  });
}
